/* unplugin-vue-components disabled */import script from "./blockPaste.vue?vue&type=script&setup=true&lang=js"
export * from "./blockPaste.vue?vue&type=script&setup=true&lang=js"

import "./blockPaste.vue?vue&type=style&index=0&id=7d6cbbe2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6cbbe2"]])

export default __exports__